module.exports = __webpack_public_path__ + "img/emptyConvocatoria.ecb97ad5.png";